import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { type Field, PuiTextArea } from '@pbt/pbt-ui-components'

import Typography from '~/components/elements/Typography/Typography'
import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

import QuestionTextField from './QuestionTextField'

interface QuestionContentFieldsProps {
  disabled: boolean
  permissions: {
    update: boolean
  }
  questionSubText: Field
  questionText: Field
}

export const QuestionContentFields = ({
  disabled,
  permissions,
  questionSubText,
  questionText,
}: QuestionContentFieldsProps) => {
  const { t } = useTranslation()
  const isQuestionsDynamicTextAndSubtextEnabled = useSelector(
    getFeatureToggle(FeatureToggle.QUESTIONS_DYNAMIC_TEXT_AND_SUBTEXT),
  )

  const handleQuestionTextFieldUpdate = (html: string) => {
    questionText.setValue(html)
  }

  const handleQuestionSubTextFieldUpdate = (html: string) => {
    questionSubText.setValue(html)
  }

  return isQuestionsDynamicTextAndSubtextEnabled ? (
    <Grid container direction="column" pb={2}>
      <Typography.H3 sx={{ paddingTop: 2 }}>
        {t('Common:QUESTION_ONE')}
      </Typography.H3>
      <QuestionTextField
        disabled={disabled || !permissions.update}
        initialText={questionText.value}
        placeholder={`${t('Admin:CATALOG.QUESTION.QUESTION_TEXT_PLACEHOLDER')}*`}
        onUpdate={handleQuestionTextFieldUpdate}
      />
      <Typography.H3 sx={{ paddingTop: 2 }}>
        {t('Admin:CATALOG.QUESTION.QUESTION_SUBTEXT_FIELD')}
      </Typography.H3>
      <QuestionTextField
        disabled={disabled || !permissions.update}
        initialText={questionSubText.value}
        placeholder={t('Admin:CATALOG.QUESTION.QUESTION_TEXT_PLACEHOLDER')}
        onUpdate={handleQuestionSubTextFieldUpdate}
      />
    </Grid>
  ) : (
    <PuiTextArea
      disabled={disabled || !permissions.update}
      field={questionText}
      placeholder={`${t('Admin:CATALOG.QUESTION.QUESTION_TEXT_PLACEHOLDER')}*`}
    />
  )
}
